import type { ReactNode } from "react";

export enum FilterType {
  MULTI_SELECT = "multi_select",
  SINGLE_SELECT = "single_select",
  RANGE = "range",
  LINK = "link",
}

export enum FilterDisplayType {
  LIST = "list",
  GRID = "grid",
  ROW = "row",
}

export type NestedFilterType = FilterType.MULTI_SELECT | FilterType.SINGLE_SELECT | FilterType.LINK;

export interface FilterConfigOption {
  id: string;
  label: ReactNode;
  value?: string | number;
  count?: number;
  prefix?: ReactNode;
  suffix?: ReactNode;
  children?: FilterConfigOption[];
  childType?: NestedFilterType;
  childId?: string;
  // When true (and parentType is "radio"), the option remains a radio input
  isSelected?: boolean;
  href?: string;
  showSearch?: boolean;
  showViewAll?: boolean;
}

export interface FilterConfigRangeOptions {
  min: number;
  max: number;
  step?: number;
  prefix?: string;
  suffix?: string;
  histogramData?: any;
}

interface BaseFilterConfigItem {
  id: string;
  label: ReactNode;
  displayType: FilterDisplayType;
  columns?: number;
  showViewAll?: boolean;
  viewAllLimit?: number;
  defaultOpen?: boolean;
  showSearch?: boolean;
}

export interface FilterConfigRangeItem extends BaseFilterConfigItem {
  type: FilterType.RANGE;
  options: FilterConfigRangeOptions;
}

export interface FilterConfigOptionItem extends BaseFilterConfigItem {
  type: Exclude<FilterType, FilterType.RANGE>;
  options: FilterConfigOption[];
  /** When option count exceeds this, clear() preserves or resets to preselectdValues. */
  preselectThreshold?: number;
  preselectdValues?: string[];
}

export type FilterConfigItem = FilterConfigRangeItem | FilterConfigOptionItem;

export interface FilterChangeArgs {
  id: string;
  value: string | number | string[] | { min?: number | string; max?: number | string } | null;
  checked?: boolean;
  config?: FilterConfigItem[];
  _e?: React.ChangeEvent<HTMLInputElement>;
}
